<template>
    <div class="categ_info" v-if="obj_to_null(this.item)">

        <info_field f_uniq="ct222" f_type="card_pay" @update_categ="change_atr" :f_title="__t('CARD_NUMBER')" :is_disabled="is_disabled" :f_val="item.card_pay" />
        <info_field f_uniq="okpo" f_type="okpo" @update_categ="change_atr" :f_title="__t('OKPO_IPN')" :is_disabled="is_disabled" :f_val="item.okpo" />
    </div>
</template>

<script>
import Info_field from "../../../../sys/info_field.vue";

export default {
    name: "employ_tips",
    components: {Info_field},
    props : {
        item : {
            type : Object
        }
    },

    methods : {
        change_atr(atr_name,atr_val) {
            this.$emit('on_change',atr_name,atr_val)
            if(this.item.hasOwnProperty(atr_name)) {
                this.item[atr_name] = atr_val;
            }
        },
    },
    computed : {
        is_disabled () {
            return false;
        },


    },
}
</script>



<style scoped>

</style>
